import 'bootstrap/dist/css/bootstrap.css';
import 'font-awesome/css/font-awesome.css';

import 'babel-polyfill';

import Vue from 'vue';
import Vuelidate from 'vuelidate';

import App from './App';

import router from './router';
import store from './store';

import api from './api';

Vue.use(Vuelidate);
Vue.use(api);
Vue.use(require('vue-cookies'));
/* eslint-disable no-new */
new Vue({
  router,
  store,
  el: '#app',
  template: '<App/>',
  components: { App },
});



// WEBPACK FOOTER //
// ./src/main.js